// EndpointsInspector.jsx
import React, { useState, useEffect } from 'react';
import EndpointsInspector from '../components/dev/EndpointsInspector';

const DevPage = () => {
    return <EndpointsInspector/>
};

export default DevPage;